
    <client-dashboard 
      [reports]="reports$ | async" 
      [displayedKeyword]="displayedKeyword" 
      [keywordColorClass]="keywordColor">
    </client-dashboard>
  